<app-dry-run-warning></app-dry-run-warning>
<div class="content max-duplicate-report-height">
    <article>
        <h2 class="heading-underline">
            <div class="back-button" (click)="backToSyncPage()">
                <i class="bhi-previous"></i>
                <span>Back to Dashboard</span>
            </div>
            Duplicate {{ mergingEntityPlural |titlecase }} Found
            <div class="search-box-wrapper">
              <input matInput placeholder="Search" class="search-box" (keyup)="applyFilter()" #searchInput>
              <mat-icon class="search-icon" (click)="clearFilter()">{{searchInput.value? 'clear':'search'}}</mat-icon>
            </div>
            <span class="sub-info">
                  Duplicate {{ mergingEntityPlural |titlecase }} Remaining:
                <span class="red"> {{ duplicateTotal }} </span> |
                Merge status:
                <div *ngIf="duplikitMergeService.anyEntityIsMerging(); then trueBlock else elseBlock"></div>
                <ng-template #elseBlock><span class="green">No merge in progress</span></ng-template>
                <ng-template #trueBlock>
                  <span class="red">
                    {{ displayEntityIsMerging() }}
                      <div class="spinner-border spinner-border-sm text-info"></div>
                  </span>
                </ng-template>
            </span>
        </h2>
        <table mat-table [dataSource]="dataSource" class="table-striped row-highlight" matSort>
            <ng-container matColumnDef="masterID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Master ID</th>
                <td mat-cell *matCellDef="let row"> {{ row.masterID }}</td>
            </ng-container>
            <ng-container matColumnDef="numDuplicates">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Number of Duplicates</th>
                <td mat-cell *matCellDef="let row"> {{ row.duplicateIDs.size }}</td>
            </ng-container>
            <ng-container matColumnDef="duplicateIDs">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Duplicate IDs</th>
                <td mat-cell *matCellDef="let row">
                    <div class="multiline-truncate">
                        {{ Array.from(row.duplicateIDs).join(', ') }}
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="button">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                    <button theme="small" (click)="$event.stopPropagation(); mergeSingleMaster(row.masterID)"> {{ row.button }}</button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: columns;"
                (click)="duplicatesDialog(row)"></tr>
        </table>
        <mat-paginator [pageSize]="25" [pageSizeOptions]="[5, 10, 25, 50]" [selectConfig]="pageSizeSelectConfig"></mat-paginator>
        <div *ngIf="isLoading" class="app-loading">
            <svg class="spinner" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
            </svg>
        </div>
        <section class="footer-btns" *ngIf="{ limit: maxDuplicatesPerMaster$ | async } as vm">
            <button (click)="downloadCSV()" appRipple theme="nav" [disabled]="duplicateTotal == 0 || isExporting()">
              {{exportButtonLabel()}} <i class="bhi-save"></i>
            </button>
            <button
                    [disabled]="userInterfaceService.duplikit.mergeButtonsDisabled || duplikitMergeService.anyEntityIsMerging() || duplicateTotal == 0"
                    appRipple theme="nav" class="has-select" (click)="mergeBatch()"
                    [matTooltip]="'Masters with more than ' + vm.limit + ' duplicates will not be merged.'"
                    [matTooltipDisabled]="!vm.limit" matTooltipShowDelay="500">
                <span>Merge </span>
                <span>
                        <select class="kyloe-select" [(ngModel)]="mergeNumber" (click)="$event.stopPropagation()">
                            <option *ngFor="let option of mergeNumberOptions">{{ option }}</option>
                        </select>
                    </span>
                <span> Duplicates</span>
                <i class="bhi-notes"></i>
            </button>
        </section>
    </article>
</div>
